import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Card, CardBody, CardTitle, Button, Input, Row, Col } from 'reactstrap';

import IntlMessages from '../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../components/DatatablePagination';
import { CSVLink } from "react-csv";
import moment from 'moment';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { gAPI_VisitorsGroupsContact_Stats } from '../../../../../constants/APIs';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';

const Contact = ({ labels, data, timeZone, propertyId, intl }) => {
  moment.tz.setDefault(timeZone);
  const csvLink = useRef(null);
  const options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: false,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
  };

  const [csvData, setCSVData] = useState([]);
  //const csvExporter = new ExportToCsv(options);
  const [downloadInput, setDownloadInput] = useState('0');
  const [ApiState, setApiState] = useState('default');
  useEffect(() => {
    if (downloadInput === '0') {
      LoadCSVFile(data);
    }
  }, [data]);
  const LoadCSVFile = (datacontact) => {
    if (datacontact !== null && datacontact !== undefined && datacontact.length > 0) {

      var tablePrint = [
        {
          r1: "Visitor Cntacts", r2: "", r3: "", r4: "", r5: "", r6: "", r7: "", r8: "", r9: "", r10: "", r11: ""
        },
        {},
        {
          r1: "Consent Date",
          r2: "Name",
          r3: "Email",
          r4: "Phone",
          r5: "Zip Code",
          r6: "Marketing Consent",
          r7: "Group Name",
          r8: "Property Name",
          r9: "Business Name",
          r10: "Chain Name",
          r11: "User Type"
        },
      ];
      datacontact.map((k) => {
        var groupName = "";
        var businessName = "";
        var propertyName = "";
        var chainName = "";
        var userType = "";
        if (k.additionalInfo !== null && k.additionalInfo !== undefined) {
          groupName = k.additionalInfo.groupName !== null && k.additionalInfo.groupName !== '' ? (k.additionalInfo.groupName) : "";
          businessName = k.additionalInfo.businessName !== null && k.additionalInfo.businessName !== '' ? (k.additionalInfo.businessName) : "";
          propertyName = k.additionalInfo.propertyName !== null && k.additionalInfo.propertyName !== '' ? (k.additionalInfo.propertyName) : "";
          chainName = k.additionalInfo.chainName !== null && k.additionalInfo.chainName !== '' ? (k.additionalInfo.chainName) : "";
          userType = k.additionalInfo.userType !== null && k.additionalInfo.userType !== '' ? (k.additionalInfo.userType) : "";
        }
        tablePrint.push({
          r1: moment(k.consentDate).format('lll'),
          r2: k.name,
          r3: k.email,
          r4: k.phone,
          r5: k.zipCode,
          r6: k.consent,
          r7: groupName,
          r8: propertyName,
          r9: businessName,
          r10: chainName,
          r11: userType
        })
      });
      setCSVData(tablePrint);
    }
  }
  const downloadCurrent = () => {
    setApiState('processing');
    setTimeout(() => {
      setApiState('success');
    }, 100);
  };
  const handleTextChange = (e) => {
    setDownloadInput(e.target.value);
    setApiState('default');
    if (e.target.value === '0') {
      LoadCSVFile(data);
    } else {
      var startDate = '';
      var endDate = moment(moment().format('YYYY-MM-DD') + ' 23:59:59')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');

      if (e.target.value === '1') {
        startDate = moment(
          moment().subtract(6, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (e.target.value === '2') {
        startDate = moment(
          moment().subtract(29, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (e.target.value === '3') {
        const today = moment();
        startDate = moment(
          moment(today).isoWeekday(1).format('YYYY-MM-DD') + ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');

        endDate = moment(
          moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (e.target.value === '4') {
        startDate = moment(
          moment().startOf('month').format('YYYY-MM-DD') + ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (e.target.value === '5') {
        startDate = moment(
          moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
          ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');

        endDate = moment(
          moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
          ' 23:59:59'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (e.target.value === '6') {
        startDate = moment(
          new Date().getFullYear() + '-01-01' + ' 00:00:00'
        ).format('YYYY-MM-DD HH:mm:ss');
      } else if (e.target.value === '7') {
        startDate = moment(
          new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00'
        ).format('YYYY-MM-DD HH:mm:ss');
        endDate = moment(
          new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00'
        ).format('YYYY-MM-DD HH:mm:ss');
      } else if (e.target.value === '8') {
        startDate = '2019-01-01';
      }

      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        LoadCSVFile(res.data);
      });
    }
  };

  return (
    <Card>
      <div style={{ padding: '15px', paddingBottom: '0px' }}>
        <div className="float-left float-none-xs">
          <div className="d-inline-block">
            <h5 className="d-inline">
              <IntlMessages id="chat.contacts"></IntlMessages>
            </h5>
            <span className="text-muted text-small d-block">
              <IntlMessages id="dashboards.contacts-prechatform-leavemessage"></IntlMessages>
              {/* Stored Contacts from Pre Chat Form & Leave Message */}
            </span>
          </div>
        </div>
        <div className="float-right form-inline text-right">
          <Input
            type="select"
            value={downloadInput}
            name="type"
            onChange={(event) => handleTextChange(event)}
          >
            <option value="0">{intl.formatMessage({ id: 'dashboards.current' })}</option>
            <option value="1">{intl.formatMessage({ id: 'dashboards.last7days' })}</option>
            <option value="2">{intl.formatMessage({ id: 'dashboards.last30days' })}</option>
            <option value="3">{intl.formatMessage({ id: 'dashboards.thisweek' })}</option>
            <option value="4">{intl.formatMessage({ id: 'dashboards.thismonth' })}</option>
            <option value="5">{intl.formatMessage({ id: 'dashboards.previousmonth' })}</option>
            <option value="6">{intl.formatMessage({ id: 'dashboards.yeartodate' })}</option>
            <option value="7">{intl.formatMessage({ id: 'dashboards.lastyear' })}</option>
            <option value="8">{intl.formatMessage({ id: 'dashboards.all' })}</option>
          </Input>
          {sessionStorage.getItem('lock') === 'true' && (
            <CSVLink data={csvData} headers={[
              { key: "r1", label: "" },
              { key: "r2", label: "" },
              { key: "r3", label: "" },
              { key: "r4", label: "" },
              { key: "r5", label: "" },
              { key: "r6", label: "" },
              { key: "r7", label: "" },
              { key: "r8", label: "" },
              { key: "r9", label: "" },
              { key: "r10", label: "" },
              { key: "r11", label: "" },
            ]} filename="visitor-contact.csv">
              <Button
                color="primary"
                onClick={downloadCurrent}
                className={`ml-2 default btn-multiple-state ${classnames({
                  'show-spinner': ApiState === 'processing',
                  'show-success': ApiState === 'success',
                  'show-fail': ApiState === 'fail',
                })}`}
              >
                <span className="spinner d-inline-block">
                  <span className="bounce1" />
                  <span className="bounce2" />
                  <span className="bounce3" />
                </span>
                <span className="icon success">
                  <i className="simple-icon-check" />
                </span>
                <span className="icon fail">
                  <i className="simple-icon-exclamation" />
                </span>
                <span className="label"><IntlMessages id='dashboards.download' /></span>
              </Button>
            </CSVLink>
          )}
        </div>
        <div className="float-right form-inline text-right mr-3">
          <Button
            color="primary"
            size="xs"
            outline
            onClick={() => (window.location.href = '/app/pages/contacts')}
          >
            <IntlMessages id='dashboards.viewallcontacts' />
          </Button>
        </div>
      </div>

      <CardBody>
        <ReactTable
          data={data}
          columns={labels}
          defaultPageSize={5}
          filterable={true}
          showPageJump={true}
          PaginationComponent={DataTablePagination}
          showPageSizeOptions={true}
          defaultCanFilter={true}
          defaultSorted={[
            {
              id: 'name',
              desc: false,
            },
          ]}
        />
      </CardBody>
    </Card>
  );
};

export default injectIntl(Contact);
